module.exports = __webpack_public_path__ + "img/horizontal_4_7_5.40684a5f.png";